
import { createApiRef } from '@backstage/core-plugin-api';
import z from 'zod';

/**
 * ApiRef for the ClusterManagementApi.
 *
 * @public
 */
export const clusterManagementApiRef = createApiRef({
  id: 'plugin.cluster-management.api',
});













export const LinkName = z.enum([
  'grafana',
  'kibana',
  'nomad',
  'adminportal',
  'prometheus',
]);



































export var DeploymentStatus; (function (DeploymentStatus) {
  const Succeed = 'Succeed'; DeploymentStatus["Succeed"] = Succeed;
  const InProgress = 'In-Progress'; DeploymentStatus["InProgress"] = InProgress;
  const Failed = 'Failed'; DeploymentStatus["Failed"] = Failed;
  const Pending = 'Pending'; DeploymentStatus["Pending"] = Pending;
})(DeploymentStatus || (DeploymentStatus = {}));






















































